import * as React from "react";

const SocialLinks = () => {
  return (
    <React.Fragment>
      <div className="whatsapp-swipe">
        <ul>
          <li className="whatsappline">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://wa.me/+919500139200"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  role="img"
                  widths={30}
                  height={30}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  alt="whatsapp"
                >
                  <path
                    fill="#fff"
                    d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z"
                  />
                </svg>
              </i>
            </a>
          </li>
          <li className="whatsappline">
            <a
              href="https://t.me/justtrytech"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  role="img"
                  alt="telegram"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.5 4.41515C17.7159 4.32429 17.9522 4.29295 18.1843 4.3244C18.4164 4.35585 18.6358 4.44894 18.8197 4.59397C19.0037 4.73901 19.1454 4.93069 19.2301 5.14907C19.3148 5.36744 19.3394 5.60453 19.3014 5.83566L17.32 17.854C17.1278 19.0133 15.8558 19.6781 14.7926 19.1007C13.9033 18.6176 12.5824 17.8732 11.3943 17.0966C10.8002 16.7078 8.98046 15.4629 9.2041 14.5771C9.3963 13.8197 12.454 10.9734 14.2012 9.28121C14.887 8.61638 14.5742 8.23287 13.7644 8.8444C11.7524 10.3627 8.52443 12.6717 7.45687 13.3217C6.51511 13.8948 6.02413 13.9926 5.43706 13.8948C4.36601 13.7166 3.3727 13.4405 2.56198 13.1042C1.46647 12.6499 1.51976 11.1438 2.56111 10.7052L17.5 4.41515Z"
                    fill="white"
                  />
                </svg>
              </i>
            </a>
          </li>
          <li className="whatsappline">
            <a
              target="_blank"
              href="https://www.linkedin.com/company/justtry-technologies/?originalSubdomain=in9"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  width={30}
                  height={33}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  role="img"
                  alt="linkedin"
                >
                  <path
                    fill="#fff"
                    d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M18.5 18.5V13.2A3.26 3.26 0 0 0 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17A1.4 1.4 0 0 1 15.71 13.57V18.5H18.5M6.88 8.56A1.68 1.68 0 0 0 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19A1.69 1.69 0 0 0 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56M8.27 18.5V10.13H5.5V18.5H8.27Z"
                  />
                </svg>
              </i>
            </a>
          </li>
          <li className="whatsappline">
            <a
              href="skype:live:.cid.74dc6fc29052d565?chat"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={25}
                  height={25}
                  viewBox="0 0 18 18"
                  fill="none"
                  role="img"
                  alt="skype"
                >
                  <path
                    d="M10.3131 17.4031C8.99079 17.6096 7.6384 17.501 6.36601 17.0861C5.09362 16.6712 3.93718 15.9617 2.99084 15.0153C2.04449 14.069 1.33498 12.9126 0.920063 11.6402C0.505142 10.3678 0.396536 9.01539 0.603087 7.69309C0.0818194 6.7016 -0.108657 5.56937 0.0594964 4.4619C0.22765 3.35443 0.745619 2.32977 1.5377 1.5377C2.32977 0.745619 3.35443 0.22765 4.4619 0.0594964C5.56937 -0.108657 6.7016 0.0818194 7.69309 0.603087C9.01539 0.396536 10.3678 0.505142 11.6402 0.920063C12.9126 1.33498 14.069 2.04449 15.0153 2.99084C15.9617 3.93718 16.6712 5.09362 17.0861 6.36601C17.501 7.6384 17.6096 8.99079 17.4031 10.3131C17.9244 11.3046 18.1148 12.4368 17.9467 13.5443C17.7785 14.6517 17.2606 15.6764 16.4685 16.4685C15.6764 17.2606 14.6517 17.7785 13.5443 17.9467C12.4368 18.1148 11.3046 17.9244 10.3131 17.4031ZM9.05609 14.1591H9.01609C11.8881 14.1591 13.3191 12.7731 13.3191 10.9161C13.3191 9.71809 12.7681 8.44509 10.5931 7.95809L8.61009 7.51809C7.85509 7.34609 6.98809 7.11809 6.98809 6.40309C6.98809 5.68809 7.60809 5.19009 8.71209 5.19009C10.9421 5.19009 10.7391 6.71809 11.8431 6.71809C12.4191 6.71809 12.9361 6.37609 12.9361 5.78809C12.9361 4.41809 10.7391 3.38809 8.88009 3.38809C6.85909 3.38809 4.70709 4.24709 4.70709 6.53209C4.70709 7.63009 5.10109 8.80209 7.26709 9.34509L9.95609 10.0161C10.7721 10.2181 10.9741 10.6751 10.9741 11.0881C10.9741 11.7751 10.2901 12.4461 9.05609 12.4461C6.63909 12.4461 6.97809 10.5891 5.68209 10.5891C5.10209 10.5891 4.67909 10.9871 4.67909 11.5601C4.67909 12.6741 6.03109 14.1591 9.05609 14.1591Z"
                    fill="white"
                  />
                </svg>
              </i>
            </a>
          </li>
          <li className="whatsappline">
            <a
              target="_blank"
              rel="noreferrer"
              href="mailto:sales@justtrytech.com"
              aria-label="Reach Justty and build your website"
            >
              <i>
                {" "}
                <svg
                  width={30}
                  height={33}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  role="img"
                  alt="gmail"
                >
                  <path
                    fill="#fff"
                    d="M20,18H18V9.25L12,13L6,9.25V18H4V6H5.2L12,10.25L18.8,6H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"
                  />
                </svg>
              </i>
            </a>
          </li>
        </ul>
      </div>
      <div className="mob_social_links">
        <ul>
          <li>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://wa.me/+919500139200"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_7374_15927)">
                    <path
                      d="M0.683437 16.188C0.682687 18.8976 1.39069 21.5434 2.73694 23.8754L0.554688 31.8431L8.70869 29.7051C10.964 30.9329 13.4909 31.5762 16.0587 31.5764H16.0654C24.5423 31.5764 31.4427 24.6785 31.4463 16.2001C31.4479 12.0917 29.8494 8.2285 26.9452 5.322C24.0414 2.41575 20.1796 0.814375 16.0648 0.8125C7.58694 0.8125 0.687063 7.71 0.683563 16.188"
                      fill="url(#paint0_linear_7374_15927)"
                    />
                    <path
                      d="M0.13375 16.1848C0.132875 18.9919 0.86625 21.7323 2.2605 24.1478L0 32.4012L8.44637 30.1866C10.7736 31.4554 13.3939 32.1244 16.0601 32.1254H16.067C24.848 32.1254 31.9963 24.9794 32 16.1976C32.0015 11.9416 30.3455 7.93944 27.3375 4.92881C24.3291 1.91856 20.3291 0.259563 16.067 0.257812C7.2845 0.257812 0.13725 7.40281 0.13375 16.1848ZM5.16388 23.7318L4.8485 23.2312C3.52275 21.1232 2.823 18.6872 2.824 16.1858C2.82675 8.88644 8.76725 2.94781 16.072 2.94781C19.6095 2.94931 22.934 4.32831 25.4345 6.83031C27.9349 9.33256 29.3108 12.6588 29.3099 16.1966C29.3066 23.4959 23.366 29.4353 16.067 29.4353H16.0618C13.6851 29.4341 11.3542 28.7958 9.3215 27.5897L8.83775 27.3028L3.8255 28.6169L5.16388 23.7318Z"
                      fill="url(#paint1_linear_7374_15927)"
                    />
                    <path
                      d="M12.0845 9.52526C11.7862 8.86239 11.4723 8.84901 11.1887 8.83739C10.9565 8.82739 10.691 8.82814 10.4257 8.82814C10.1602 8.82814 9.72883 8.92801 9.3642 9.32614C8.9992 9.72464 7.9707 10.6876 7.9707 12.6463C7.9707 14.6049 9.39733 16.4979 9.5962 16.7638C9.79533 17.0291 12.3503 21.1771 16.3968 22.7729C19.7598 24.099 20.4442 23.8353 21.1741 23.7688C21.9041 23.7025 23.5296 22.806 23.8612 21.8764C24.1931 20.9469 24.1931 20.1501 24.0936 19.9836C23.9941 19.8178 23.7286 19.7181 23.3305 19.5191C22.9323 19.3201 20.975 18.3569 20.6101 18.224C20.2451 18.0913 19.9797 18.025 19.7142 18.4236C19.4487 18.8216 18.6863 19.7181 18.454 19.9836C18.2218 20.2498 17.9895 20.2829 17.5915 20.0838C17.1931 19.884 15.911 19.4641 14.3898 18.108C13.2063 17.0528 12.4073 15.7496 12.1751 15.351C11.9428 14.953 12.1502 14.7373 12.3498 14.5389C12.5287 14.3605 12.7481 14.074 12.9473 13.8416C13.1458 13.6091 13.2121 13.4433 13.3448 13.1778C13.4777 12.912 13.4112 12.6795 13.3118 12.4804C13.2121 12.2813 12.4385 10.3124 12.0845 9.52526Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_7374_15927"
                      x1="1545.14"
                      y1="3103.88"
                      x2="1545.14"
                      y2="0.8125"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#1FAF38" />
                      <stop offset="1" stopColor="#60D669" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_7374_15927"
                      x1="1600"
                      y1="3214.6"
                      x2="1600"
                      y2="0.257812"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#F9F9F9" />
                      <stop offset="1" stopColor="white" />
                    </linearGradient>
                    <clipPath id="clip0_7374_15927">
                      <rect
                        width="32"
                        height="32.25"
                        fill="white"
                        transform="translate(0 0.257812)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              Whatsapp
            </a>
          </li>
          <li>
            <a
              href="https://t.me/justtrytech"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_7374_15934)">
                    <path
                      d="M16 0.382812C11.7575 0.382812 7.685 2.06956 4.6875 5.06906C1.68693 8.06977 0.000858621 12.1393 0 16.3828C0 20.6246 1.6875 24.6971 4.6875 27.6966C7.685 30.6961 11.7575 32.3828 16 32.3828C20.2425 32.3828 24.315 30.6961 27.3125 27.6966C30.3125 24.6971 32 20.6246 32 16.3828C32 12.1411 30.3125 8.06856 27.3125 5.06906C24.315 2.06956 20.2425 0.382812 16 0.382812Z"
                      fill="url(#paint0_linear_7374_15934)"
                    />
                    <path
                      d="M7.24311 16.2148C11.9081 14.1828 15.0181 12.8432 16.5731 12.1958C21.0181 10.3476 21.9406 10.0266 22.5431 10.0157C22.6756 10.0136 22.9706 10.0463 23.1631 10.202C23.3231 10.3332 23.3681 10.5107 23.3906 10.6353C23.4106 10.7598 23.4381 11.0436 23.4156 11.2651C23.1756 13.7951 22.1331 19.9346 21.6031 22.7683C21.3806 23.9673 20.9381 24.3693 20.5106 24.4086C19.5806 24.4941 18.8756 23.7946 17.9756 23.2048C16.5681 22.2816 15.7731 21.7071 14.4056 20.8063C12.8256 19.7653 13.8506 19.1931 14.7506 18.2581C14.9856 18.0133 19.0806 14.2896 19.1581 13.9518C19.1681 13.9096 19.1781 13.7521 19.0831 13.6691C18.9906 13.5858 18.8531 13.6143 18.7531 13.6368C18.6106 13.6688 16.3631 15.1558 12.0031 18.0976C11.3656 18.5361 10.7881 18.7498 10.2681 18.7386C9.69811 18.7263 8.59811 18.4156 7.78061 18.1501C6.78061 17.8243 5.98311 17.6521 6.05311 17.0988C6.08811 16.8108 6.48561 16.5161 7.24311 16.2148Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_7374_15934"
                      x1="1600"
                      y1="0.382812"
                      x2="1600"
                      y2="3200.38"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#2AABEE" />
                      <stop offset="1" stopColor="#229ED9" />
                    </linearGradient>
                    <clipPath id="clip0_7374_15934">
                      <rect
                        width="32"
                        height="32"
                        fill="white"
                        transform="translate(0 0.382812)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              Telegram
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/justtry-technologies/?originalSubdomain=in9"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_7510_13692)">
                    <path
                      d="M24.5 0.0625H7.5C3.35786 0.0625 0 3.42036 0 7.5625V24.5625C0 28.7046 3.35786 32.0625 7.5 32.0625H24.5C28.6421 32.0625 32 28.7046 32 24.5625V7.5625C32 3.42036 28.6421 0.0625 24.5 0.0625Z"
                      fill="white"
                    />
                    <path
                      d="M24.5 0.0625H7.5C3.35786 0.0625 0 3.42036 0 7.5625V24.5625C0 28.7046 3.35786 32.0625 7.5 32.0625H24.5C28.6421 32.0625 32 28.7046 32 24.5625V7.5625C32 3.42036 28.6421 0.0625 24.5 0.0625Z"
                      fill="#0A66C2"
                    />
                    <path
                      d="M23.0894 27.2731H26.7481C26.8807 27.2731 27.0079 27.2205 27.1016 27.1267C27.1954 27.033 27.2481 26.9058 27.2481 26.7733L27.25 19.043C27.25 15.0026 26.3794 11.897 21.6577 11.897C19.8629 11.8303 18.1702 12.7555 17.2569 14.3005C17.2524 14.308 17.2456 14.3138 17.2375 14.3171C17.2294 14.3204 17.2205 14.3209 17.2121 14.3187C17.2036 14.3164 17.1962 14.3114 17.1908 14.3045C17.1855 14.2976 17.1826 14.2891 17.1825 14.2804V12.77C17.1825 12.6374 17.1298 12.5102 17.0361 12.4164C16.9423 12.3227 16.8151 12.27 16.6825 12.27H13.2104C13.0778 12.27 12.9506 12.3227 12.8568 12.4164C12.7631 12.5102 12.7104 12.6374 12.7104 12.77V26.7725C12.7104 26.9051 12.7631 27.0323 12.8568 27.1261C12.9506 27.2198 13.0778 27.2725 13.2104 27.2725H16.8689C17.0015 27.2725 17.1287 27.2198 17.2224 27.1261C17.3162 27.0323 17.3689 26.9051 17.3689 26.7725V19.8509C17.3689 17.8938 17.7401 15.9984 20.1665 15.9984C22.5584 15.9984 22.5894 18.2379 22.5894 19.9776V26.7731C22.5894 26.9057 22.6421 27.0329 22.7358 27.1267C22.8296 27.2204 22.9568 27.2731 23.0894 27.2731ZM4.75 7.516C4.75 8.999 5.97088 10.2192 7.454 10.2192C8.93675 10.2191 10.1569 8.99813 10.1569 7.51538C10.1566 6.03263 8.93637 4.8125 7.4535 4.8125C5.97025 4.8125 4.75 6.033 4.75 7.516ZM5.61987 27.2731H9.28325C9.41586 27.2731 9.54304 27.2204 9.6368 27.1267C9.73057 27.0329 9.78325 26.9057 9.78325 26.7731V12.77C9.78325 12.6374 9.73057 12.5102 9.6368 12.4164C9.54304 12.3227 9.41586 12.27 9.28325 12.27H5.61987C5.48727 12.27 5.36009 12.3227 5.26632 12.4164C5.17255 12.5102 5.11987 12.6374 5.11987 12.77V26.7731C5.11987 26.9057 5.17255 27.0329 5.26632 27.1267C5.36009 27.2204 5.48727 27.2731 5.61987 27.2731Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7510_13692">
                      <rect
                        width="32"
                        height="32"
                        fill="white"
                        transform="translate(0 0.0625)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              LinkedIn
            </a>
          </li>
          <li>
            <a
              href="skype:live:.cid.74dc6fc29052d565?chat"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                {" "}
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_7374_15940)">
                    <path
                      d="M30.8335 18.3712C30.9268 17.7177 30.9749 17.0585 30.9776 16.3984C30.9775 12.4246 29.3989 8.61356 26.5889 5.80365C23.779 2.99374 19.9679 1.41512 15.9941 1.41505C15.3341 1.4178 14.675 1.46593 14.0215 1.55905C10.3281 -0.431446 5.76623 0.237179 2.7996 3.20405C-0.16702 6.17093 -0.83577 10.7324 1.15473 14.4258C1.0616 15.0793 1.01348 15.7383 1.0106 16.3984C1.0106 24.6737 7.71898 31.3819 15.9941 31.3819C16.6541 31.3792 17.3134 31.3311 17.9669 31.2379C21.6601 33.2284 26.2219 32.5598 29.1887 29.5929C32.1554 26.6263 32.8241 22.0644 30.8335 18.3712Z"
                      fill="white"
                    />
                    <path
                      d="M9.49834 19.3873C14.7377 19.3873 18.985 15.14 18.985 9.90069C18.985 4.66137 14.7377 0.414062 9.49834 0.414062C4.25903 0.414062 0.0117188 4.66137 0.0117188 9.90069C0.0117188 15.14 4.25903 19.3873 9.49834 19.3873Z"
                      fill="url(#paint0_linear_7374_15940)"
                    />
                    <path
                      d="M22.4886 32.3795C27.7279 32.3795 31.9752 28.1322 31.9752 22.8929C31.9752 17.6536 27.7279 13.4062 22.4886 13.4062C17.2493 13.4062 13.002 17.6536 13.002 22.8929C13.002 28.1322 17.2493 32.3795 22.4886 32.3795Z"
                      fill="url(#paint1_linear_7374_15940)"
                    />
                    <mask
                      id="mask0_7374_15940"
                      style={{
                        maskType: "luminance",
                      }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="32"
                      height="33"
                    >
                      <path
                        d="M22.4879 13.4063C20.7918 13.4059 19.1267 13.8613 17.667 14.725C20.1089 10.6075 19.1044 5.31591 15.3234 2.37954C11.5425 -0.557089 6.16713 -0.220465 2.78188 3.16479C-0.603245 6.54991 -0.93987 11.9254 1.99663 15.7063C4.933 19.4873 10.2245 20.4918 14.3423 18.0499C12.156 21.7552 12.7369 26.4679 15.7575 29.5314C18.7783 32.5949 23.4823 33.242 27.218 31.108C30.9538 28.974 32.7858 24.5933 31.6811 20.4353C30.5766 16.2772 26.8124 13.383 22.5099 13.3842L22.4879 13.4063Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_7374_15940)">
                      <path
                        d="M15.6933 34.8046C25.4834 34.8046 33.4198 26.8681 33.4198 17.0781C33.4198 7.28799 25.4834 -0.648438 15.6933 -0.648438C5.90322 -0.648438 -2.0332 7.28799 -2.0332 17.0781C-2.0332 26.8681 5.90322 34.8046 15.6933 34.8046Z"
                        fill="url(#paint2_radial_7374_15940)"
                      />
                    </g>
                    <path
                      d="M15.9933 31.3811C24.2684 31.3811 30.9768 24.6727 30.9768 16.3976C30.9768 8.1224 24.2684 1.41406 15.9933 1.41406C7.71811 1.41406 1.00977 8.1224 1.00977 16.3976C1.00977 24.6727 7.71811 31.3811 15.9933 31.3811Z"
                      fill="url(#paint3_linear_7374_15940)"
                    />
                    <path
                      d="M15.9933 31.3811C24.2684 31.3811 30.9768 24.6727 30.9768 16.3976C30.9768 8.1224 24.2684 1.41406 15.9933 1.41406C7.71811 1.41406 1.00977 8.1224 1.00977 16.3976C1.00977 24.6727 7.71811 31.3811 15.9933 31.3811Z"
                      fill="url(#paint4_linear_7374_15940)"
                    />
                    <path
                      d="M10.5306 14.5569C10.1782 13.8962 10.0026 13.1555 10.0208 12.4069C9.99817 11.4607 10.3213 10.5388 10.9296 9.81367C11.5696 9.09154 12.3871 8.54906 13.3012 8.23992C14.2941 7.88943 15.3402 7.71321 16.3932 7.71905C17.0834 7.71432 17.7728 7.76621 18.4544 7.87417C18.9405 7.95561 19.4188 8.07796 19.8842 8.23992C20.3069 8.38592 20.6874 8.63325 20.9924 8.9603C21.2253 9.2227 21.3518 9.56262 21.3471 9.91342C21.3556 10.0973 21.3277 10.2811 21.2649 10.4542C21.2021 10.6273 21.1058 10.7862 20.9813 10.9219C20.8652 11.0456 20.7241 11.1431 20.5675 11.208C20.4108 11.273 20.2421 11.3039 20.0726 11.2987C19.8352 11.2951 19.6013 11.2423 19.3854 11.1435C18.8634 10.9123 18.3265 10.716 17.7784 10.556C17.2685 10.4227 16.7429 10.3594 16.2159 10.3678C15.533 10.3449 14.8572 10.5138 14.2653 10.8553C14.0162 11.0066 13.8126 11.2225 13.676 11.48C13.5395 11.7375 13.475 12.0272 13.4896 12.3183C13.4856 12.697 13.6286 13.0624 13.8886 13.3378C14.2066 13.6658 14.5823 13.9326 14.9968 14.1247C15.4512 14.3463 16.1051 14.6455 17.0359 15.0224L17.3241 15.1332C18.2032 15.4682 19.0461 15.8915 19.8398 16.3965C20.4722 16.8065 21.0059 17.3515 21.4024 17.9924C21.7923 18.6647 21.988 19.432 21.9677 20.2089C21.9991 21.1606 21.7232 22.0971 21.1808 22.8798C20.6244 23.6327 19.8509 24.1973 18.9643 24.4979C17.9157 24.8718 16.808 25.052 15.6949 25.0298C14.1732 25.0801 12.6592 24.7925 11.2619 24.1875C10.904 24.0264 10.589 23.7835 10.3422 23.4783C10.1482 23.1906 10.0475 22.85 10.0541 22.503C10.0419 22.3202 10.0704 22.137 10.1375 21.9664C10.2045 21.7959 10.3085 21.6424 10.4419 21.5168C10.719 21.2716 11.0809 21.1443 11.4504 21.162C11.8636 21.168 12.2697 21.2705 12.6362 21.4613C13.0906 21.6829 13.4452 21.8603 13.7444 21.971C14.0411 22.0965 14.3491 22.193 14.6643 22.2592C15.0532 22.3476 15.4514 22.3885 15.8502 22.3812C16.556 22.4331 17.2587 22.2457 17.8449 21.8492C18.0663 21.6796 18.2435 21.4591 18.3612 21.2063C18.4789 20.9535 18.5337 20.676 18.5209 20.3974C18.5316 19.987 18.3803 19.5889 18.0998 19.2892C17.7383 18.9207 17.3191 18.6137 16.8586 18.3804C16.3156 18.0922 15.5398 17.7487 14.5536 17.3275C13.6673 16.9747 12.8173 16.5368 12.0156 16.0198C11.4161 15.621 10.8934 15.1789 10.5306 14.5569Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_7374_15940"
                      x1="800.171"
                      y1="11.4945"
                      x2="1097.18"
                      y2="1886.66"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.01" stopColor="#00B7F0" />
                      <stop offset="0.34" stopColor="#009DE5" />
                      <stop offset="0.76" stopColor="#0082D9" />
                      <stop offset="1" stopColor="#0078D4" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_7374_15940"
                      x1="139.345"
                      y1="1436.4"
                      x2="1783.98"
                      y2="487.738"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#0078D4" />
                      <stop offset="0.37" stopColor="#007AD5" />
                      <stop offset="0.57" stopColor="#0082D9" />
                      <stop offset="0.74" stopColor="#0090DF" />
                      <stop offset="0.88" stopColor="#00A3E7" />
                      <stop offset="1" stopColor="#00BCF2" />
                    </linearGradient>
                    <radialGradient
                      id="paint2_radial_7374_15940"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(1718.82 1772) scale(1773.39)"
                    >
                      <stop />
                      <stop offset="1" stopOpacity="0" />
                    </radialGradient>
                    <linearGradient
                      id="paint3_linear_7374_15940"
                      x1="913.085"
                      y1="484.602"
                      x2="2411.44"
                      y2="3080.13"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#00B7F0" />
                      <stop offset="1" stopColor="#007CC1" />
                    </linearGradient>
                    <linearGradient
                      id="paint4_linear_7374_15940"
                      x1="1368.58"
                      y1="2992.57"
                      x2="1630.14"
                      y2="6.95802"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#0078D4" />
                      <stop offset="1" stopColor="#00BCF2" />
                    </linearGradient>
                    <clipPath id="clip0_7374_15940">
                      <rect
                        width="32"
                        height="32"
                        fill="white"
                        transform="translate(0 0.382812)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              Skype
            </a>
          </li>
          <li>
            <a
              href="mailto:sales@justtrytech.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Reach Justty and build your website"
            >
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="30"
                  viewBox="0 0 32 25"
                  fill="none"
                >
                  <g clipPath="url(#clip0_7509_13680)">
                    <path
                      d="M7.27275 24.0058V11.642L3.43837 8.13413L0 6.1875V21.8239C0 23.0311 0.978125 24.0058 2.18187 24.0058H7.27275Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M24.7266 24.0056H29.8174C31.0248 24.0056 31.9993 23.0274 31.9993 21.8237V6.1875L28.1048 8.41713L24.7266 11.6419V24.0056Z"
                      fill="#34A853"
                    />
                    <path
                      d="M7.2737 11.642L6.75195 6.81112L7.2737 2.1875L16.001 8.733L24.7282 2.1875L25.3118 6.5615L24.7282 11.642L16.001 18.1875L7.2737 11.642Z"
                      fill="#EA4335"
                    />
                    <path
                      d="M24.7266 2.18796V11.6425L31.9993 6.18796V3.27884C31.9993 0.580712 28.9193 -0.957414 26.7631 0.660711L24.7266 2.18796Z"
                      fill="#FBBC04"
                    />
                    <path
                      d="M0 6.18802L3.34488 8.69677L7.27275 11.6425V2.18802L5.23625 0.660769C3.07625 -0.957481 0 0.580769 0 3.27877V6.18802Z"
                      fill="#C5221F"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7509_13680">
                      <rect width="32" height="24.125" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              Mail
            </a>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default SocialLinks;
